const zh = {
	plInput: '请输入',
	async: '同步',
	cancel: '取消',
	confirm: '确定',
	editSucces: '修改成功',
	editError: '修改失败',
	add: '添加',
	mobile: '手机',
	email: '邮箱',
	major: '专业',
	team: '团队',
	avatar: '头像',
	name: '姓名',
	eName: '英文名',
	cName: '中文名',
	phone: '手机号',
	tips: '提示：以下为同步来的信息，仅供参考',
	allProject: '全部项目',
	allClint: '全部分端服务器',
	plSelect: '请选择',
	parameter: '参数',
	note: '短信',
	plPhone: '请输入手机号',
	allTeam: '全部团队',
	allMajor: '全部专业',
	centerSer: '中心服务器',
	plCorrectPhone: '请给出正确的手机号',
	plrGraphicCode: '请输入图形验证码',
	myPhone: '你当前的手机号码是',
	myPhopneTips: ',修改手机时系统会发送验证码到新的手机号码上，然后输入验证码后完成修改。',
	back: '返回用户登录',
	adminLogin: '后台管理登录',
	serError: '服务器错误',
	noEmpty: '不能为空',
	url: '域名',
	timeTips1: '发送短信过于频繁,请在',
	timeTips2: '秒后再次发送短信。',
	currentPage: '当前页面共',
	page: '页',
	go: '前往',
	total: '共',
	strip: '条',
	emailError: '邮件格式有误，请检查',
	updateInfo: '修改信息',
	info: '基本信息',
	updatePhone: '修改手机',
	accessSatus: '已接入',
	access: '接入',
	addSucces: '添加成功',
	roleUpdateSucces: '权限更新成功',
	updateInfoSucces: '基本信息更新成功',
	serverOffLine: '服务器已离线',
	asyncSucces: '同步成功',
	backOff: '断开',
	passwordInequality: '两次密码不一样,请重新输入',
	plCode: '请输入验证码',
	noSearch: '暂无搜索结果，看看其他的吧~',
	uploadFail: '上传失败',
	search: '搜索',
	wasNotFound: '未查找到该结果',
	signOut: '退出',
	updateLanguage: '修改语言',
	noData: '暂无数据',
	disconnected: '已断开',
	synchronizationSucceeded: '同步成功',
	changeRecord: '变更记录',
	exitSystem: '退出系统',
	getInto: '进入',
	allStates: '全部状态',
	zh: '中文',
	en: '英文',
	selectMajorTag: '请选择专业标签',
	selectTeamTag: '请选择团队标签',
	upload: '上传',
	passwordResetSuccee: '密码重置成功',
	projectOverview: '项目概览',
};

export default zh;
